import { BaseEntity } from '../../../app/core';

export class Vehicle extends BaseEntity {
    id: number;
    internalNumber: number;
    policyNumber: number;
    since: Date;
    sinceString: string;
    until: Date;
    untilString: string;
    chassis: string;
    brand: string;
    model: string;
    domain: string;
    engineNumber: string;
    year: number;
    type: string;

    constructor(since: Date, until: Date) {
        super();
        this.sinceString = this.dateToString(since);
        this.untilString = this.dateToString(until);
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/vehicle.ts